<template>
  <div>
    <ul
      class="text unit-text"
      :class="{open: isOpenAll}"
      ref="text"
      :style="{height: height + 'px'}"
    >
      <li
        class="title"
        :class="{open: isOpenAll}"
        @click="toggleOpenHeader"
      >
        {{ label }}
      </li>
      <li class="flex-box" v-if="target !== 'mobile'">
        <!-- フォント -->
        <select-box
          v-if="showSettingItem('fontFamily')"
          :target="'font-family-name'"
          :value="styles['font-family-name'] || null"
          @updateStyles="updateStyles($event)"
        />
        <!-- 揃え位置 -->
        <select-button
          v-if="showSettingItem('textAlign')"
          :target="'text-align'"
          :value="styles['text-align'] || 'left'"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <li class="flex-box">
        <!-- 文字の間隔 -->
        <select-box
          v-if="showSettingItem('letterSpacing')"
          :target="'letter-spacing'"
          :value="styles['letter-spacing'] || null"
          @updateStyles="updateStyles($event)"
        />
        <!-- フォントサイズ -->
        <select-box
          v-if="showSettingItem('fontSize')"
          :target="'font-size'"
          :value="styles['font-size'] || null"
          @updateStyles="updateStyles($event)"
        />
        <!-- 行の高さ -->
        <select-box
          v-if="showSettingItem('lineHeight')"
          :target="'line-height'"
          :value="styles['line-height'] || null"
          @updateStyles="updateStyles($event)"
        />
        <!-- 文字色 -->
        <select-color
          v-if="showSettingItem('color')"
          :type="'selector'"
          :target="'color'"
          :selector="selector"
          :value="styles['color'] || null"
          @updateStyles="updateStyles($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'

const ONE_LINE_HEIGHT = 40
const PAGE_HEIGHT = 200

export default {
  name: 'content-design-text',
  props: [
    'target', // page or mobile
    'selector',
    'label',
    'styles',
  ],
  components: {
    SelectColor,
    SelectBox,
    SelectButton,
  },
  data () {
    return {
      height: ONE_LINE_HEIGHT,
      heightAll: 0,
      isOpenAll: false,
    }
  },
  computed: {
    showSettingItem () {
      return function (itemName) {
        // page：全項目表示
        // page以外：フォントサイズと行の高さのみ表示
        return this.target === 'page' || (itemName === 'fontSize' || itemName === 'lineHeight')
      }
    },
  },
  mounted () {
    // pageの時は、高さを変える
    this.heightAll = this.target === 'page' ? PAGE_HEIGHT : this.$refs.text.scrollHeight + 10
  },
  methods: {
    updateStyles (styles) {
      this.$emit('updateStyles', {
        selector: this.selector,
        styles: styles
      })
    },
    toggleOpenHeader () {
      this.isOpenAll = !this.isOpenAll
      if (this.isOpenAll) {
        this.height = this.heightAll
      } else {
        this.height = ONE_LINE_HEIGHT
      }
    },
    // TODO: 「パーツのスタイルがnullの場合」対応時に修正する
    // deleteStyle (prop) {
    //   this.$emit('deletePageCss', {
    //     selector: this.selector,
    //     prop: prop,
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.text{
  color: $commonFontColor;
  margin: 0;
  height: 0;
  border-bottom: 0.5px solid #dbdbdb;
  overflow: hidden;
  transition: all 0.3s ease 0s;
  background: #E4E4E4;
  &.open {
    height: 290px;
    overflow: visible;
    &>li:not(.title) {
      opacity: 1;
    }
  }
  > li {
    padding: 0 10px 0;
    margin: 10px 0;
    &.title {
      display: block;
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      padding:0 20px 0;
      margin: 0;
      border-bottom: 0.5px solid #dbdbdb;
      background: #f8f8f8;
      position: relative;
      &::after {
        font-family: "Font Awesome 5 Free";
        content: '\f107';
        font-weight: 900;
        position: absolute;
        top: 0;
        right: 0;
        transition: all 0.1s ease 0s;
        padding: 0 20px;
        cursor: pointer;
      }
      &.open::after {
        transform: rotate(180deg)
      }
    }
    &:not(.title) {
      opacity: 0;
      transition: all 0.3s ease 0s;
    }
    &.font {
      width: 250px;
    }
    &.font-color {
      width: 150px;
    }
  }
  .flex-box {
    align-items: flex-end;
  }
}
</style>

<style lang="scss">
.unit-text {
  .edit-style-select-color {
    padding-bottom: 7px;
  }
}
</style>
